import {useTranslation} from "react-i18next";
import Page from "../../common/page/Page";
import {MessageTranslKey} from "./MessageTranslKey";
import {useState} from "react";
import {IsdsMessageInfoDto} from "../../client/message/IsdsMessageApiClient";
import MessageSearchPanel from "./MessageSearchPanel";
import {DetailActionButton} from "../../common/button/CommonActionButtons";
import MessageDetailPanel from "./detail/MessageDetailPanel";

export function MessagePage() {
    const [selectedMessage, setSelectedMessage] = useState<IsdsMessageInfoDto>();
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);

    const {t} = useTranslation();

    function onDetailDialogClose() {
        setDetailDialogOpen(false)
    }

    function onMessageSelected(message?: IsdsMessageInfoDto) {
        setSelectedMessage(message);
    }

    function showDetailDialog() {
        setDetailDialogOpen(true);
    }

    const actions: React.ReactNode = (
        <>
            <DetailActionButton onClick={() => showDetailDialog()}
                                disabled={!selectedMessage} />
        </>
    );

    return (
        <Page title={t(MessageTranslKey.ISDS_MESSAGE_OVERVIEW)}>
            <MessageSearchPanel actions={actions}
                                onSelectedMessage={onMessageSelected}
                                onMessageDoubleClick={showDetailDialog}/>

            {selectedMessage && detailDialogOpen &&
                <MessageDetailPanel messageId={selectedMessage.id}
                                   open={detailDialogOpen}
                                   onClose={onDetailDialogClose} />
            }
        </Page>
    );
}
